import React, { useState, useEffect } from 'react';
import { cn } from '../lib/utils';
import Header from '../Components/Common/Header';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from '../Components/Common/Sidebar';
import Footer from '../Components/Common/Footer';

const SIDEBAR_COOKIE_NAME = "sidebar_state";
const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7; // 7 days

const Layout = ({ children }) => {
  /*
  // Cookie-based state initialization
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${SIDEBAR_COOKIE_NAME}=`);
    if (parts.length === 2) {
      const cookieVal = parts.pop().split(';').shift();
      return cookieVal === 'true';
    }
    return true;
  });
  */

  // Initialize sidebar: closed by default on mobile/tablet, open/user-preferred on desktop
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const isDesktop = window.innerWidth >= 768;
    const savedState = localStorage.getItem('sidebarOpen');
    return isDesktop ? (savedState !== null ? JSON.parse(savedState) : true) : false;
  });

  // Automatically adjust sidebar state when crossing mobile/desktop breakpoints on resize
  useEffect(() => {
    let prevIsDesktop = window.innerWidth >= 768;

    const handleResize = () => {
      const isDesktop = window.innerWidth >= 768;
      if (isDesktop !== prevIsDesktop) {
        setIsSidebarOpen(isDesktop);
        prevIsDesktop = isDesktop;
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => {
      const newState = !prev;
      /*
      // Cookie-based save
      document.cookie = `${SIDEBAR_COOKIE_NAME}=${newState}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`;
      */

      // LocalStorage-based save (Fallback)
      // Only persist preferences if toggled on desktop
      if (window.innerWidth >= 768) {
        localStorage.setItem('sidebarOpen', JSON.stringify(newState));
      }
      return newState;
    });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex overflow-hidden">
      {/* Mobile Sidebar Backdrop Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40 md:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* Persistent Sidebar */}
      <div className={cn("w-0 shrink-0 transition-all duration-300 md:w-64", !isSidebarOpen && "md:w-0")}>
        <Sidebar isVisible={isSidebarOpen} toggleSidebar={toggleSidebar} />
      </div>

      {/* Main Content Area */}
      {/* <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden relative z-20"></div> */}
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">
        <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />

        <main className="flex-1 overflow-y-auto scroll-smooth bg-[#F7F4EA]">
          <div className="animate-in fade-in duration-500">
            {children}
          </div>
        </main>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Layout;
